import React from 'react';

const TestimonialIcon = ({ width = 32, height = 23, color = "#22242A" }) => (
    <svg width={width} height={height} viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.456 23.04C3.616 23.04 0.447998 19.968 0.447998 15.168C0.447998 8.736 4.096 3.072 6.4 0.48C6.784 0.0959988 7.072 0 7.456 0H8.704C9.376 0 9.664 0.48 9.376 1.056C8.224 3.552 7.456 6.432 7.456 9.12C11.392 9.12 14.464 12.192 14.464 16.128C14.464 19.968 11.392 23.04 7.456 23.04ZM24.544 23.04C20.704 23.04 17.536 19.968 17.536 15.168C17.536 8.736 21.184 3.072 23.488 0.48C23.872 0.0959988 24.16 0 24.544 0H25.792C26.464 0 26.752 0.48 26.464 1.056C25.312 3.552 24.544 6.432 24.544 9.12C28.48 9.12 31.552 12.192 31.552 16.128C31.552 19.968 28.48 23.04 24.544 23.04Z" fill={color} />
    </svg>

);

export default TestimonialIcon;